<template>
  <div>
    <div class="info-key">* {{ $t("message.incumbent") }}</div>
  </div>
</template>

<script>
export default {};
</script>
